import { render, staticRenderFns } from "./Havelaar.vue?vue&type=template&id=2e6c08f9"
import script from "./Havelaar.vue?vue&type=script&lang=js"
export * from "./Havelaar.vue?vue&type=script&lang=js"
import style0 from "./Havelaar.vue?vue&type=style&index=0&id=2e6c08f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports